import { render, staticRenderFns } from "./SuperPayLaunch.vue?vue&type=template&id=4a7fd6b0&scoped=true&"
import script from "./SuperPayLaunch.vue?vue&type=script&lang=ts&"
export * from "./SuperPayLaunch.vue?vue&type=script&lang=ts&"
import style0 from "./SuperPayLaunch.scss?vue&type=style&index=0&id=4a7fd6b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7fd6b0",
  null
  
)

export default component.exports